import { api, config, helpers, ts } from '_core';

type BasketApiResponse = {
  data: ts.types.basket.Basket;
};

export const createBasket = async (
  newData: ts.types.basket.BasketDraft,
  callback: (_data: ts.types.basket.Basket) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: BasketApiResponse = await api.baskets.create(newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating basket - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateBasket = async (
  id: number,
  newData: ts.types.basket.BasketDraft,
  callback: (_data: ts.types.basket.Basket) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: BasketApiResponse = await api.baskets.update(id, { ...newData });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating basket - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  id: number,
  definition: ts.types.basket.DefinitionDraft,
  isValid: boolean,
  callback: (_data: ts.types.basket.Basket) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp = await api.baskets.update(
      id,
      {
        definition,
        is_valid: isValid,
        skip_signature_check: !isValid,
      },
      true
    );
    if (resp.data?.validation_error && !resp.data?.is_valid) errorCallback(resp.data?.validation_error);
    else callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateUiMetadata = async (
  basket: ts.types.basket.Basket,
  uiMetaData: ts.types.basket.UiMetaData,
  callback: (_data: ts.types.basket.Basket) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    if (basket.shared) return;
    const updateData = {
      ui_metadata: uiMetaData,
      skip_signature_check: true,
    } as ts.types.basket.BasketDraft;
    const resp = await api.baskets.update(basket.id, updateData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the resource metadata - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const keepCurrent = async (
  basket: ts.types.basket.BasketDraft,
  callback: (_data: { resource: ts.types.basket.Basket; universe?: ts.types.universe.Universe }) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    if (basket.shared) return;
    const resp = await api.dates.keep_current({
      resource_id: basket.id,
      resource_type: 'baskets',
      universe_id: basket.definition?.universe_id || undefined,
      countries:
        (basket.definition as ts.types.basket.DefinitionCommon)?.etf_definition?.quotation_countries || undefined,
      frequency: (basket.definition?.frequency as ts.enums.FREQUENCY_ENUM) || undefined,
      max_date: config.features.end_date,
    });
    callback(resp);
  } catch (error) {
    errorCallback(`Error updating basket dates - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};
